



























import { Component, Vue, Prop } from 'vue-property-decorator';
import TableView from '@/components/storage/storageList/directoryContents/views/TableView.vue';
import StorageSubHeader from '@/components/storage/storageList/storageSubHeader.vue';
import CommonButton from '@/components/common/CommonButton.vue';
import DirectoryListNavigationDrawer from '@/components/storage/drawers/directoryListNavigationDrawer/DirectoryListNavigationDrawer.vue';

@Component({
  components: {
    TableView,
    CommonButton,
    StorageSubHeader,
    DirectoryListNavigationDrawer,
  },
})
export default class StorageResult extends Vue {
  public checkBoxArray: Array<number> = [];
  private foldersAndFiles: { folders: number; files: number } = {
    folders: 4,
    files: 6,
  };
}
